import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { jsx as _jsx } from "react/jsx-runtime";
const ICON_STYLES = {
  circle_color: 'circle_color',
  circle_black: 'circle_black',
  circle_grey: 'circle_grey',
  original_black: 'original_black',
  square_color: 'square_color',
  square_black: 'square_black',
  square_grey: 'square_grey'
};

// TODO: Figure out real solution for where icon images should come from
const getStyleIconSrc = styleName => `https://static.hsstatic.net/TemplateAssets/static-1.17/img/hs_default_template_images/modules/Follow%20Me%20-%20Email/facebook_${styleName}.png`;
export default function SocialIconStyleField({
  readOnly,
  value,
  onFieldChange
}) {
  return /*#__PURE__*/_jsx(Flex, {
    flexWrap: "wrap",
    gap: "300",
    marginBlockEnd: "300",
    children: Object.keys(ICON_STYLES).map(styleName => /*#__PURE__*/_jsx(SelectableBox, {
      type: "default",
      blockSize: "1600",
      inlineSize: "1600",
      padding: "200",
      onSelectedChange: () => onFieldChange(styleName),
      selected: value === styleName,
      readOnly: readOnly,
      children: /*#__PURE__*/_jsx(Image, {
        blockSize: "1000",
        inlineSize: "1000",
        src: getStyleIconSrc(styleName)
      })
    }, styleName))
  });
}